import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants/constants';
import { getValueFromStorage } from '../helpers/helpers';

export const AnnouncementsApi = createApi({
  reducerPath: 'announcements',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-type', 'application/json');
      headers.set('authorization', `Bearer ${getValueFromStorage('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getAnnouncements: builder.query({
      query: () => ({
        url: `api/announcement/getAnnouncements`,
        method: 'GET',
      }),
    }),
    addAnnouncement: builder.mutation({
      query: body => ({
        url: `api/announcement/createAnnouncement`,
        method: 'POST',
        body: body,
      }),
    }),
  }),
});

export const {
  useGetAnnouncementsQuery,
  useLazyGetAnnouncementsQuery,
  useAddAnnouncementMutation,
} = AnnouncementsApi;
